// Slug + label list for the 8 stationery landing pages.
// Kept tiny so Layout/Footer/Home can import it without pulling page content.
export const STATIONERY_NAV = [
  { slug: "luxury-wedding-invitations", label: "Luxury Wedding Invitations" },
  { slug: "premium-wedding-stationery", label: "Premium Wedding Stationery" },
  { slug: "acrylic-wedding-invitations", label: "Acrylic Wedding Invitations" },
  { slug: "wedding-invitation-boxes", label: "Wedding Invitation Boxes" },
  { slug: "wedding-welcome-signs", label: "Wedding Welcome Signs" },
  { slug: "save-the-date-cards", label: "Save The Date Cards" },
  { slug: "wedding-itinerary-cards", label: "Wedding Itinerary Cards" },
  { slug: "wedding-monograms", label: "Wedding Monograms" },
];
